import {packageId} from '@/config';
import {useEffect, useMemo, useState} from 'react';
import {getUrl} from './const';
import globalStore from '@/services/global.state';
import {useRoute} from '@react-navigation/native';
import {useLatest} from 'ahooks';
import {envConfig, getDeviceCode} from '@/utils';
const getDefaultParams = () => {
  return {
    channelId: globalStore.channel,
    packageId,
    deviceCode: getDeviceCode(),
    apiUrl: envConfig.baseUrl,
  };
};

export function useGameUrlWithToken(path: string) {
  const [token, setToken] = useState('');
  const url = useMemo(() => {
    const qsParams: any = {
      ...getDefaultParams(),
    };
    if (token) {
      qsParams.token = token;
    }
    return getUrl(path, qsParams);
  }, [path, token]);
  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(newToken => {
      setToken(newToken || '');
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  return {
    url,
  };
}
export function useGameUrl(path: string) {
  const route = useRoute();
  const params = route.params || {};
  const latestParams = useLatest(params || {});
  const url = useMemo(() => {
    const qsParams: any = {
      ...getDefaultParams(),
      ...latestParams.current,
    };
    return getUrl(path, qsParams);
  }, [path, latestParams]);
  return {
    url: url,
  };
}
